<template>
    <span class="page-tooltip-container">
        <v-popover trigger="click"
                   placement="bottom"
                   popoverBaseClass="PageTooltip__container"
                   popoverInnerClass="page-tooltip-inner"
                   :open.sync="open">
            <IconBase
                :width="iconWidth"
                :height="iconHeight"
                :iconColor="open ? iconHoverColor : iconColor"
                :iconHoverColor="iconHoverColor"
                :iconName="icon"
                @click.stop.prevent.native="open = true"/>
            <template slot="popover">
            <span class="close-button-wrapper">
                  <span class="close-button" @click="open = false">
                      <IconBase iconName="closeIcon"
                                class="close-icon"
                                :iconColor="closeIcon.color"
                                :width="closeIcon.size"
                                :height="closeIcon.size"
                                v-once></IconBase>
                  </span>
            </span>
                <slot name="tooltip-content">
                    <div class="page-tooltip-content-container">
                        <div class="page-tooltip-text page-tooltip-title font-4" v-if="title">{{title}}</div>
                        <div class="page-tooltip-text font-5" v-if="text">{{text}}</div>
                        <a class="page-tooltip-link font-4" v-if="link" :href="link" target="_blank">{{linkText}}</a>
                    </div>
                </slot>
            </template>
        </v-popover>
    </span>
</template>

<script>

import consts from 'services/metaData/consts';
import IconBase from 'components/IconBase.vue';

export default {
    name: 'PageTooltip',
    components: { IconBase },
    data() {
        return {
            consts,
            open: false,
            closeIcon: {
                color: consts.COLORS.LIGHT_700,
                size: 8
            }
        };
    },
    props: {
        placement: {
            type: String,
            default: 'bottom',
            validator: (val) => ['bottom', 'top', 'left', 'right'].includes(val)
        },
        popoverClass: String,
        title: String,
        text: String,
        note: String,
        link: String,
        linkText: {
            type: String,
            default: 'Learn more'
        },
        icon: {
            type: String,
            default: 'questionCircleIcon'
        },
        iconColor: {
            type: String,
            default: consts.COLORS.LIGHT_700
        },
        iconHoverColor: {
            type: String,
            default: consts.COLORS.LIGHT_900
        },
        iconHeight: {
            type: [String, Number],
            default: 16
        },
        iconWidth: {
            type: [String, Number],
            default: 16
        }
    }
};
</script>

<style lang="scss">
/* Needs to be global since v-poopover appends to body */
.PageTooltip__container {
    z-index: 1;

    &:focus {
        outline: none;
    }
}
</style>

<style scoped lang="scss">
@import "~styles/styleGuide";

.close-button-wrapper {
    float: right;
    cursor: pointer;
    transform: translateY(10px) translateX(-16px);
}

.page-tooltip-container {
    margin-left: 6px;
    cursor: pointer;
}

.page-tooltip-content-container {
    background: $white;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
    padding: 22px 24px 24px 24px;
    width: 448px;
    margin-top: 4px;
}

.page-tooltip-title {
    margin-bottom: 10px;
}

.page-tooltip-text {
    color: $light-800;
    line-height: 18px;
    white-space: pre-wrap;
}

.page-tooltip-link {
    color: $primary-500;
    text-decoration: none;
    line-height: 18px;
    margin-top: 18px;
    display: block;
}
</style>
